import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OptimizerSessionTokenState {
  OptimizerSessionToken: null | number;
}

const initialState: OptimizerSessionTokenState = {
  OptimizerSessionToken: null,
};

const OptimizerSessionTokenSlice = createSlice({
  name: "OptimizerSessionToken",
  initialState,
  reducers: {
    setOptimizerRuvnlSessionToken: (state, action: PayloadAction<number>) => {
      state.OptimizerSessionToken = action.payload;
    },
    clearOptimizerRuvnlSessionToken: (state) => {
      state.OptimizerSessionToken = null;
    },
  },
});

export const { setOptimizerRuvnlSessionToken, clearOptimizerRuvnlSessionToken } = OptimizerSessionTokenSlice.actions;
export default OptimizerSessionTokenSlice.reducer;
